export default function IconVolumeDown() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 11C4 10.4477 4.44772 10 5 10H8V22H5C4.44772 22 4 21.5523 4 21V11Z" fill="white" />
      <path d="M8 10L13.3492 5.41496C13.9979 4.85896 15 5.31987 15 6.17422V25.8258C15 26.6801 13.9979 27.141 13.3492 26.585L8 22V10Z"
            fill="white" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M17 20.0388C17 20.5911 17.4564 21.0522 17.9872 20.8994C19.8412 20.366 21.2192 18.3639 21.2192 15.9755C21.2192 13.5871 19.8412 11.585 17.9872 11.0516C17.4564 10.8988 17 11.3599 17 11.9122V20.0388Z"
            fill="white" />
    </svg>
  );
}
